var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskMantisLockupStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 220,
    viewBox: "0 0 360 220",
    role: "img",
    "aria-label": "Task Mantis",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 50 L38 72 L66 44",
    fill: "none",
    stroke: "#7C5CFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 7.5,
    fill: "#7C5CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 72,
    r: 7.5,
    fill: "#7C5CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 32,
    r: 9.5,
    fill: "none",
    stroke: "#7C5CFF",
    strokeWidth: 6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 168,
    textAnchor: "middle",
    fontFamily: "Outfit, 'Helvetica Neue', Arial, sans-serif",
    fontSize: 52,
    fontWeight: 500,
    letterSpacing: -0.8,
    fill: "#F2F3F8"
  }, "Task Mantis")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskMantisLockupStacked);
export default __webpack_public_path__ + "static/media/task-mantis-lockup-stacked.2ba763b21f80822a5d08418ffdd389dd.svg";
export { ForwardRef as ReactComponent };